import React from 'react';
import { useLocation } from 'react-router-dom';
import styles from './WhatsAppButton.module.css';
import { waLink, trackLead } from '../../data/contact';

const WhatsAppButton: React.FC = () => {
  // The FAB is global, so the page the visitor was on is the only clue to what
  // they were looking at — carry it into the message.
  const { pathname } = useLocation();
  const source = `Floating chat button · ${pathname}`;

  return (
    <a
      href={waLink('Hi Rashed Al Shamsi, I need help choosing products for custom branding.', source)}
      className={styles.whatsappBtn}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackLead('whatsapp', source)}
      aria-label="Chat with us on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className={styles.icon}
        aria-hidden="true"
      >
        <path
          d="M16 0C7.163 0 0 7.163 0 16c0 2.822.736 5.472 2.027 7.77L0 32l8.437-2.012A15.93 15.93 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.77-1.853l-.486-.288-5.006 1.194 1.227-4.872-.317-.502A13.267 13.267 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.3-9.984c-.4-.2-2.363-1.165-2.73-1.298-.366-.133-.633-.2-.9.2-.266.4-1.033 1.298-1.266 1.565-.233.266-.466.3-.866.1-.4-.2-1.69-.623-3.218-1.984-1.19-1.059-1.993-2.367-2.226-2.767-.233-.4-.025-.616.175-.815.18-.18.4-.466.6-.7.2-.233.266-.4.4-.666.133-.266.066-.5-.033-.7-.1-.2-.9-2.167-1.233-2.967-.325-.779-.657-.673-.9-.686l-.766-.013c-.267 0-.7.1-1.067.5-.366.4-1.4 1.367-1.4 3.334 0 1.966 1.433 3.867 1.633 4.133.2.267 2.82 4.304 6.833 6.034 4.013 1.73 4.013 1.153 4.733 1.08.72-.073 2.363-.966 2.696-1.9.333-.933.333-1.733.233-1.9-.1-.167-.366-.267-.766-.467z"
          fill="currentColor"
        />
      </svg>
      <span className={styles.label}>Need Help?</span>
    </a>
  );
};

export default WhatsAppButton;
